import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {action, observable, runInAction} from 'mobx';
import './styles.scss';
import {AudioRecorder} from "../../../utils/audioUtility";
import {getDeviceLatency, setDeviceLatency} from "../../../utils/userUtility";
import {actions, category, events, LatencyTestState} from "../../../constants/enums";
import {ReactComponent as Headphones} from '../../../assets/images/latencyTest/headphones.svg';
import {ReactComponent as Volume} from '../../../assets/images/latencyTest/volume.svg';
import {ReactComponent as Silent} from '../../../assets/images/latencyTest/silent.svg';
import {ReactComponent as Done} from '../../../assets/images/latencyTest/done.svg';
import {ReactComponent as RunningIcon} from '../../../assets/images/latencyTest/latency.svg';
import {customEvent} from "../../../utils/analyticsUtil";

@observer
class LatencyTest extends Component {
    // @observable result = {success: true, errCode:LatencyTestError.TooLittle };
    @observable result = null;
    @observable numTries = 0;
    @observable testState = LatencyTestState.Preparation;
    recorderInstance = null;

    @action handleTestState = val => {
        this.testState = val;
    }

    @action onStartLatencyTest = async () => {
        this.recorderInstance = new AudioRecorder(120, () => {}, this.latencyTestDone);
        await this.recorderInstance.init();
        runInAction(async () => {
            this.handleTestState(LatencyTestState.Running)
            this.numTries++;
            await this.recorderInstance.runLatencyTest();
        })
    };

    @action latencyTestDone = (result) => {
        this.result = result;
        this.handleTestState(this.result.success ? LatencyTestState.Success : LatencyTestState.Error);
        customEvent(events.CustomEvent, {category: category.Record, action: actions.LatencyTest, label: JSON.stringify(this.result)});
    };

    @action onDone = () => {
        if (this.result?.success) {
            setDeviceLatency(this.result.latencyMs);
        } else {
            let currentLatency = getDeviceLatency();
            if (!currentLatency) {
                setDeviceLatency('skip');
            }
        }
        this.props.onLatencyDone();
    };

    renderBody = () => {
        switch (this.testState) {
            case LatencyTestState.Preparation:
                return <>
                    <p className="latency-calculator-description">
                        <FormattedMessage id="upload.latencyTest.desk.preparation"/>
                    </p>
                    <p className="latency-calculator-description">
                        <FormattedMessage id="upload.latencyTest.desk.preparation2"/>
                    </p>
                </>;
            case LatencyTestState.Init:
                return <div className="latency-calculator-items">
                    <div className="latency-wrapper-init">
                        <Headphones />
                        <div className="latency-calculator-item-label"><FormattedMessage id={"upload.latencyTest.initLine1"}/></div>
                    </div>
                    <div className="latency-wrapper-init">
                        <Volume />
                        <div className="latency-calculator-item-label"><FormattedMessage id={"upload.latencyTest.initLine2"}/></div>
                    </div>
                    <div className="latency-wrapper-init">
                        <Silent />
                        <div className="latency-calculator-item-label"><FormattedMessage id={"upload.latencyTest.initLine3"}/></div>
                    </div>
                </div>;
            case LatencyTestState.Running:
                return <div className="latency-calculator-items running">
                    <p className="latency-calculator-description running">
                        <FormattedMessage id="upload.latencyTest.runningDesc"/>
                    </p>
                    <RunningIcon />
                </div>;
            case LatencyTestState.Error:
                return <div className="latency-calculator-items">
                    <p className="latency-calculator-description">
                        <FormattedMessage id={this.numTries > 1 ? "upload.latencyTest.errorDesc.others" : "upload.latencyTest.errorDesc.first"}/>
                    </p>
                </div>;
            case LatencyTestState.Success:
                return <div className="latency-calculator-items success">
                    <p className="latency-calculator-description">
                        <FormattedMessage id="upload.latencyTest.successDesc"/>
                    </p>
                    <Done />
                </div>;
            default:
                return null;
        }
    }


    renderActionButton = () => {
        switch (this.testState) {
            case LatencyTestState.Preparation:
                return <>
                    <button className={"latency-calculator-btn"} onClick={() => this.handleTestState(LatencyTestState.Init)}>
                        <FormattedMessage id={"upload.latencyTest.startSetup"}/>
                    </button>
                    <button className={"latency-calculator-btn without"} onClick={this.onDone}>
                        <FormattedMessage id={"upload.latencyTest.withoutSetup"}/>
                    </button>
                </>;
            case LatencyTestState.Init:
                return <button className={"latency-calculator-btn"} onClick={this.onStartLatencyTest}>
                    <FormattedMessage id={"upload.latencyTest.start"}/>
                </button>;
            case LatencyTestState.Running:
                return <button className={"latency-calculator-btn running"} disabled={true}>
                    <FormattedMessage id={"upload.latencyTest.running"}/>
                </button>;
            case LatencyTestState.Error:
                let TryAgain = <button className={"latency-calculator-btn try-again"} onClick={this.onStartLatencyTest}>
                    <FormattedMessage id={"upload.latencyTest.tryAgain"}/>
                </button>;
                if (this.numTries > 1) {
                    return <div className="latency-calculator-btn-with-skip">
                        {TryAgain}
                        <button className={"latency-calculator-btn without"} onClick={this.onDone}>
                            <FormattedMessage id={"upload.latencyTest.withoutSetup"}/>
                        </button>
                    </div>;
                }
                return TryAgain;
            case LatencyTestState.Success:
                return <button className={"latency-calculator-btn"} onClick={this.onDone}>
                    <FormattedMessage id={'upload.latencyTest.done'}/>
                </button>;
            default:
                return null;
        }
    };

    renderHeaderTitle = () => {
        switch (this.testState) {
            case LatencyTestState.Preparation:
                return <FormattedMessage id="upload.latencyTest.title.preparation"/>;
            case LatencyTestState.Init:
                return <FormattedMessage id="upload.latencyTest.title.init"/>;
            case LatencyTestState.Running:
                return <FormattedMessage id="upload.latencyTest.title.running"/>;
            case LatencyTestState.Success:
                return <FormattedMessage id="upload.latency.title.success" />;
            case LatencyTestState.Error:
                return <FormattedMessage id={this.numTries > 1 ? "upload.latencyTest.title.error.others" : "upload.latencyTest.title.error.first"} />;
            default:
                return null;
        }
    }


    render() {
        return (
            <div className={`latency-calculator-container ${this.testState}`}>
                <h3 className="latency-calculator-title">
                    {this.renderHeaderTitle()}
                </h3>
                <div className="latency-calculator-body">
                    {this.renderBody()}
                </div>
                <div className="latency-calculator-btn-wrapper">
                    {this.renderActionButton()}
                </div>
            </div>
        );
    }
}

export default LatencyTest;
